module.exports = __webpack_public_path__ + "img/design.2b315220.png";